var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.dialog
        ? _c("ProjectModal", {
            attrs: { companyId: _vm.companyId, currentUser: _vm.currentUser },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
      _c(
        "UiButtonTests",
        {
          attrs: {
            id: "newProjectButton",
            disabled: _vm.noCompany,
            size: _vm.size,
            variant: "blue",
          },
          on: { click: _vm.toggle },
        },
        [_c("div", [_vm._v(_vm._s(_vm.text))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }